import { isBot } from 'isbot';
import { analyticsClient } from '../common/analyticsClient';
import type { AnalyticsEventRequest } from './utils/types';

const KNOWN_TRANSPORT_PATTERN = /^(?:node|(?:axios|okhttp)\/\d+(?:\.\d+){1,3})$/;
const WEBVIEW_TOKEN_PATTERN = /(?:^|\s)SkinSeoul-ReactNative-WebView(?=\s|$)/;
const GOOGLE_PAY_TOKEN_PATTERN = /(^|\s)GOOGLE_PAY_SUPPORTED(?=\s|$)/g;

class AnalyticsAPIClient {
  public async trackEvent(payload: AnalyticsEventRequest): Promise<void> {
    if (isKnownWebCrawler(payload)) {
      return;
    }

    if (!payload.uniqueId) {
      payload.uniqueId = createAnalyticsEventId();
    }
    await analyticsClient.post('/a/event', payload);
  }
}

export const analyticsAPIClient = new AnalyticsAPIClient();

function isKnownWebCrawler(payload: AnalyticsEventRequest): boolean {
  if (payload.analytics.platform !== 'Web' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent;
  if (!userAgent || KNOWN_TRANSPORT_PATTERN.exec(userAgent)?.[0] === userAgent) {
    return false;
  }

  // The app capability contains "Google" but is not a crawler identity.
  const candidate = WEBVIEW_TOKEN_PATTERN.test(userAgent)
    ? userAgent.replace(GOOGLE_PAY_TOKEN_PATTERN, '$1')
    : userAgent;
  return isBot(candidate);
}

export function createAnalyticsEventId(): string {
  const randomUUID = globalThis.crypto?.randomUUID;
  if (typeof randomUUID === 'function') {
    return randomUUID.call(globalThis.crypto);
  }
  return `evt_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}
